import * as React from 'react';

import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import { Invoice } from '@services/payment/types/invoice';

import moment from 'moment';

import styled from 'styled-components';

import InvoiceItemCtrl from './invoice-item';
import Typography from '@components/basics/typography';

interface InvoicesCtrlProps {
  className?: string;
  invoices: Invoice[];
}

const mapStateToProps = (state: AppState) => ({
  invoices: state.subscription.invoices.sort((a, b) => Number(new Date(b.invoice_date)) - Number(new Date(a.invoice_date)))
})

const formatInvoiceDate = (date: Date) => {
  return moment(date).format('LL');
}

export const InvoicesCtrl: React.FC<InvoicesCtrlProps> = (props) => {
  return (
    <div className={props.className}>
      <Typography className="mb-20" type="subheader" weight="400">Invoices</Typography>
      {
        props.invoices.map((invoice, i) => (
          <InvoiceItemCtrl
            className="invoice-item"
            key={`invoice-item-${i}`}
            invoiceNumber={invoice.description}
            invoiceDate={formatInvoiceDate(invoice.invoice_date)}
            invoiceStatus={invoice.status}
            invoiceUrl={invoice.url}
          />
        ))
      }

      {
        !props.invoices.length ? (
          <Typography weight="700" opacity=".5">No Invoices</Typography>
        ) : null
      }
    </div>
  )
}

export default connect(mapStateToProps)(styled(InvoicesCtrl)`
  .invoice-item {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`);